import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import apiService from '../api/apiService';
import { userAuth } from '../contexts/userContext';
import { useNavigate } from 'react-router-dom';

const PointsContext = createContext();

export const PointsProvider = ({ children }) => {
	const [availablePoints, setAvailablePoints] = useState(null);
	const [loadingPoints, setLoadingPoints] = useState(false);
	const [pointsError, setPointsError] = useState(null);
	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	const fetchAvailablePoints = useCallback(
		async (force = false) => {
			if (!token?.session_key) return;

			if (!force && availablePoints !== null) return;

			setLoadingPoints(true);
			setPointsError(null);

			const item = { action: 'get_available_points' };

			try {
				const response = await apiService(item, token, setToken, navigate);

				if (!response || response?.type === 'error') {
					setPointsError(response?.message || 'Failed to fetch points.');
					setAvailablePoints(null);
					return;
				}

				setAvailablePoints(response.available_points ?? 0);
				// setAvailablePoints(5);
			} catch (error) {
				setPointsError('An error occurred while fetching points.');
				setAvailablePoints(null);
			} finally {
				setLoadingPoints(false);
			}
		},
		[token, setToken, navigate, availablePoints],
	);

	useEffect(() => {
		if (token?.session_key && availablePoints === null) {
			fetchAvailablePoints();
		} else if (!token?.session_key) {
			setAvailablePoints(null);
			setPointsError(null);
		}
	}, [token, fetchAvailablePoints, availablePoints]);

	return (
		<PointsContext.Provider
			value={{ availablePoints, loadingPoints, pointsError, fetchAvailablePoints }}>
			{children}
		</PointsContext.Provider>
	);
};

export const usePoints = () => useContext(PointsContext);
